import { useEffect, useState } from "react";

/** Returns true when viewport width < breakpoint (default 640px). */
export function useIsMobile(breakpoint = 640) {
    const [isMobile, setIsMobile] = useState(() =>
        typeof window !== "undefined" && window.innerWidth < breakpoint
    );
    useEffect(() => {
        const onResize = () => setIsMobile(window.innerWidth < breakpoint);
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, [breakpoint]);
    return isMobile;
}
